/**
 * This page will display the event associated to the ID in the page's route.
 */

import { GetStaticPaths, GetStaticProps } from "next";
import ShareEventPage, {
  getEventStaticPaths,
  getEventShareStaticProps,
} from "@dreambigger/inspire-events/src/components/views/share";

// Get the static paths for the event that we want to prerender.
export const getStaticPaths: GetStaticPaths = getEventStaticPaths;

// Get data to statically generate the actual event.
export const getStaticProps: GetStaticProps = getEventShareStaticProps;

export default ShareEventPage;
